import $ from "jquery";
// import ua from "../libs/userAgent.js";
import "slick-carousel";

$(document).ready(function () {
  $(".top-description__img").slick({
    autoplay: true,
    autoplaySpeed: 0,
    speed: 20000,
    cssEase: "linear",
    swipe: false,
    arrows: false,
    pauseOnFocus: false,
    pauseOnHover: false,
  });

  $(".top-mv-bg").slick({
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 1000,
    fade: true,
    cssEase: "linear",
    arrows: false,
    dots: false,
    infinite: true,
    pauseOnFocus: false,
    pauseOnHover: false,
  });

  $(".top-slide").slick({
    autoplay: true,
    autoplaySpeed: 0,
    speed: 10000,
    cssEase: "linear",
    slidesToScroll: 1,
    infinite: true,
    arrows: false,
    dots: false,
    swipe: false,
    pauseOnFocus: false,
    pauseOnHover: false,
    variableWidth: true,
  });

});
